import { render } from "./DatenblattMod.vue?vue&type=template&id=7703b800&scoped=true"
import script from "./DatenblattMod.vue?vue&type=script&lang=js"
export * from "./DatenblattMod.vue?vue&type=script&lang=js"

import "./DatenblattMod.vue?vue&type=style&index=0&id=7703b800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7703b800"]])

export default __exports__